<template>
    <div class="modal fade" id="createModal" tabindex="-1" role="dialog" aria-labelledby="createModal" aria-hidden="true">
        <div class="modal-dialog" role="document">
        <form action="ohyes" method="POST" id='create_form' @submit.prevent="form_submit()">
            <input id="create_status" type="hidden" value="error">
            <div class="modal-content">
                <div class="modal-header bg-system">
                    <strong class="modal-title text-white">Create Main Category</strong>
                    <button @click="triggerReset()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span class="text-white" aria-hidden="true" >&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="form-group mb-1">
                        <label for="com">
                            Main Category<span class="text-danger"> * select this for make it as Sub Category *</span>
                        </label>
                        <select v-model="parent_id" id="com" class="border-page-color selectPicker form-control" data-size="5" data-live-search="true">
                            <option value="0">PLEASE SELECT ONE</option>
                            <option :value="main.id" v-for="main in mainCategories" :key="main.id">{{ main.name }}</option>
                        </select>
                    </div>
                    <div class="form-group mb-1">
                        <label>
                            Name <span class="text-danger">*</span>
                        </label>
                        <input v-model="name" type="text" name="name" class="form-control" required>
                    </div>
                    <div class="form-group mb-1">
                        <label for="">Product Image</label>
                        <div class="w-100">
                            <input id="photo" @change="changeImg('photo',$event)" type="file">
                            <button type="button" @click="resetImg('photo')" v-if="pho" title="Reset Photo" class="border-0 rounded outline-0 float-right btn-outline-dark"><i class="fas fa-redo-alt"></i></button>
                            <img v-if="phoo" :src="photo" class="my-2 w-25 rounded">
                        </div>
                    </div>  
                </div>
                <div class="modal-footer">
                    <button :disabled="isCreate" type="submit" class="btn btn-system btn-xs">
                        <img v-if="isCreate" src="../../../assets/sniper.jpeg" alt="" width="12">
                        <i v-else class="fa fa-save"></i> Save
                    </button>
                    <button type="button" class="btn btn-danger btn-xs" data-dismiss="modal" 
                        @click="triggerReset()">
                        <i class="fa fa-times"></i> Close
                    </button>
                </div>
            </div>
        </form>
        </div>
    </div>  
</template> 
<script>
import { frm_submit } from '@/networks/services/helper/button'

export default {
    props : {
        mainCategories: {
            type: [String, Object],
            default: null,
        },
    },
    data(){
        return {
            name : null,
            tbl : "main_categories",
            per : "main_category",
            parent_id : 0,
            photo : '',
            pho: false,
            phoo: null,
            isCreate : false
        }
    },
    methods: {
        triggerReset(){
            // $('#createModal').on('hidden.bs.modal', function () {
            //     $(this).find('form').trigger('reset');
            // })
            this.photo = '';
            this.name = '';
            this.pho = false;
            this.phoo = null;
            this.isCreate = false;
        },
        resetImg(value){
            if(value == "photo"){
                this.photo = '';
                this.pho = false;
                this.phoo = null;
                $('#photo').val('');
            }
        },
        changeImg(value,obj){
            if(value == "photo"){
                this.photo = URL.createObjectURL(obj.target.files[0]);
                this.phoo = obj.target.files[0];
                this.pho = true;
            }
        },
        async form_submit(){
            this.isCreate = true;
            var data = new FormData();
            data.append('name',this.name);
            data.append('parent_id',this.parent_id);
            data.append('tbl',this.tbl);
            data.append('per',this.per);
            data.append('photo',this.phoo);
            await frm_submit(data);
            this.triggerReset();
            this.$emit("createModal",$('#create_status').val()); 

        },
    },
    mounted(){
        $(document).ready(function() {
            $('.chosen2').select2();
        });
    }
}
</script>
